module.exports = __webpack_public_path__ + "img/amx.9eeabde6.jpg";